<template>
  <div class="dropdown" :class="{collapsed: collapsed, 'dropdown--selectable': selectable}" v-on-clickaway="onClose">
    <div class="dropdown__btn" 
        :class="{'flex flex--align-vertical': buttonIconName, 'flex--row-reverse': buttonIconLeft}" 
        @click="onToggle">
      <span class="text-size-13 text-height-1" v-if="buttonText">{{buttonText}}</span>
      <eta-progress :sliderValue="buttonTextEta" :sliderPercentage="buttonPercentageEta" v-if="buttonEtaShow"></eta-progress>
      <!-- TODO remove (icon--chevron-down) -->
      <span class="icon text-height-1" 
        v-if="buttonIconName && buttonIconName !== 'icon--chevron-down'"
        :class="[{ml5: buttonText && !buttonIconLeft}, buttonIconName, buttonIconSize, buttonIconColor]"></span>
      <svg v-if="buttonIconName && buttonIconName == 'icon--chevron-down'" class="icon icon--chevron-down ml4" width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.99896 2.84506L0.927172 0.141524C0.715077 -0.0452716 0.371131 -0.0452167 0.159037 0.141609C-0.0530122 0.328181 -0.0530122 0.630769 0.159037 0.817645L3.6159 3.86004C3.82805 4.04669 4.17204 4.04661 4.38404 3.86004C4.39318 3.85198 4.40193 3.84372 4.41028 3.83525L7.84081 0.815987C8.05309 0.62933 8.05305 0.326607 7.84076 0.139951C7.62871 -0.0466503 7.28497 -0.0466503 7.07258 0.139951L3.99896 2.84506Z"/>
      </svg>
    </div>

    <transition name="dropdown">
      <ul class="dropdown__content" v-if="collapsed && contentList" @click="onClose">
        <button class="btn btn--mobile-close" @click="onClose"><span class="icon-remove"></span></button>
        <slot name="item" v-for="item in dropdownList" :item="item" v-if="dropdownList"></slot>
        <slot name="items" v-if="!dropdownList"></slot>
      </ul>

      <div class="dropdown__content" v-if="collapsed && !contentList">
        <button class="btn btn--mobile-close" @click="onClose"><span class="icon-remove"></span></button>
        <slot name="content"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
  import { mixin as clickaway } from 'vue-clickaway'
  import Eta from 'components/pages/project/task/Eta'

  export default {
    name: 'dropdown',

    mixins: [ clickaway ],

    data () {
      return {
        collapsed: false
      }
    },

    components: {
      'eta-progress': Eta
    },

    props: {
      dropdownList: {
        type: Array
      },
      buttonIcon: {
        type: Boolean,
        required: false,
        default: true
      },
      buttonIconSize: {
        type: String,
        required: false,
        default: ''
      },
      buttonIconName: {
        type: String,
        required: false,
        default: ''
      },
      buttonIconColor: {
        type: String,
        required: false,
        default: ''
      },
      buttonIconLeft: {
        type: Boolean,
        required: false,
        default: false
      },
      buttonText: {
        type: String,
        required: false,
        default: ''
      },
      buttonEtaShow: {
        type: Boolean,
        required: false,
        default: false
      }, 
      buttonTextEta: {
        type: Number,
        required: false,
        default: 0
      },
      buttonPercentageEta: {
        type: Number,
        required: false,
        default: 0
      },
      selectable: {
        type: Boolean,
        required: false,
        default: true
      },
      contentList: {
        type: Boolean,
        required: false,
        default: true
      }
    },

    methods: {
      bindEvents () {
        this.$bus.$on('closeEtaSlider', () => {
          this.collapsed = false
        })
      },

      unbindEvents () {
        this.$bus.$off('closeEtaSlider')
      },

      onToggle () {
        this.collapsed = !this.collapsed
      },

      onClose () {
        this.collapsed = false
      }
    },

    created () {
      this.bindEvents()
    },

    beforeDestroy () {
      this.unbindEvents()
    }
  }
</script>


// WEBPACK FOOTER //
// Dropdown.vue?381291c2